import React, { useState, useEffect } from "react";
import ItemService from "../../services/supplier_appCommonService";
import LoaderSmall from "../LoaderSmall";
import "./StatsGrid.css";

const StatsGrid = ({ queryConfigs = [], refreshInterval }) => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    let interval;

    const fetchAllStats = async () => {
      try {
        setLoading(true);

        const results = await Promise.all(
          queryConfigs.map(async (config) => {
            try {
              if (config.directCount !== undefined) {
                return {
                  title: config.title,
                  value: config.directCount ?? 0,
                  subValue: config.value ?? 0,
                  Icon: config.icon,
                  navigateKey: config.navigateKey,
                };
              }
              if (config.value !== undefined) {
                return {
                  title: config.title,
                  value: config.value ?? 0,
                  subValue: 0,
                  Icon: config.icon,
                  navigateKey: config.navigateKey,
                };
              }
              const res = config.fetchFunction
                ? await config.fetchFunction()
                : await ItemService.generateQuery({
                    queryName: config.queryName,
                  });

              let count = 0;
              let value = 0;
              if (
                typeof res?.data === "object" &&
                res?.data !== null &&
                !Array.isArray(res.data)
              ) {
                count = res.data.count ?? 0;
                value = res.data.value ?? 0;
              } else if (
                Array.isArray(res?.data) &&
                res.data[0]?.count !== undefined
              ) {
                count = res.data[0]?.count ?? 0;
                value = res.data[0]?.value ?? 0;
              } else if (typeof res?.data === "number") {
                count = res.data;
              } else if (typeof res?.total === "number") {
                count = res.total;
              }
              if (
                config.valueKey &&
                Array.isArray(res?.data) &&
                typeof res?.total === "number"
              ) {
                if (count === 0) {
                  count = res.total;
                }

                if (value === 0) {
                  value = res.data.reduce((sum, row) => {
                    const currentValue = Number(row?.[config.valueKey]);

                    return (
                      sum + (Number.isNaN(currentValue) ? 0 : currentValue)
                    );
                  }, 0);
                }
              }

              return {
                title: config.title,
                value: count ?? 0,
                subValue: value ?? 0,
                Icon: config.icon,
                navigateKey: config.navigateKey,
              };
            } catch (err) {
              console.error(`StatsGrid error for [${config.title}]:`, err);

              return {
                title: config.title,
                value: 0,
                subValue: 0,
                Icon: config.icon,
                navigateKey: config.navigateKey,
              };
            }
          }),
        );

        if (!mounted) return;

        setStats(results);
      } catch (error) {
        console.error("StatsGrid Fatal Error:", error);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchAllStats();

    if (refreshInterval) {
      interval = setInterval(fetchAllStats, refreshInterval);
    }

    return () => {
      mounted = false;

      if (interval) {
        clearInterval(interval);
      }
    };
  }, [queryConfigs, refreshInterval]);

  return (
    <div className="stats-grid-container">
      {loading ? (
        <div className="stats-grid-loader">
          <LoaderSmall isLoading />
        </div>
      ) : (
        <div className="stats-grid">
          {stats.map((item, index) => (
            <div key={index} className="stats-card">
              <div className="stats-header">
                {item.Icon && (
                  <div className="icon-wrapper">
                    <div className="icon-box">
                      <item.Icon className="icon" />
                    </div>
                  </div>
                )}

                <h3 className="stats-title">{item.title}</h3>
              </div>
              <p className="stats-value">
                {Number(item.value ?? 0).toLocaleString()}
              </p>
              {Number(item.subValue) > 0 && (
                <div className="stats-footer">
                  <span className="stats-badge">
                    ₹ {Number(item.subValue).toLocaleString()}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatsGrid;
